// Client V2 common imports
const collectionSelectModalActions = require('client-v2/common/containers/collection-select-modal/actions')
const collectionSelectModalSelectors = require('client-v2/common/containers/collection-select-modal/selectors')
const articleModelActions = require('client-v2/common/models/article/actions')
const userModelActions = require('client-v2/common/models/user/actions')
// Container imports
const feedActions = require('../containers/feed/actions')
const statsActions = require('../containers/profile-user-stats/actions')

/** @typedef { import('redux').Middleware } ReduxMiddleware */

// Middlewares

/**
 * @returns {ReduxMiddleware}
 */
// eslint-disable-next-line complexity
function userProfileStatsSideEffectsMiddleware() {
  return store => next => action => {
    const state = store.getState()
    if (action.type === userModelActions.USER_FOLLOWING_CHANGE) {
      const { isFollowing } = action.payload
      if (
        state.profileUser.id === action.payload.userId &&
        isFollowing !== userModelActions.USER_FOLLOWING_CHANGE_PENDING
      ) {
        const amount = isFollowing ? 1 : -1
        store.dispatch(statsActions.adjustFollowingCount(amount))
      }
    }
    if (state.profileUser.id === state.user.id) {
      if (action.type === articleModelActions.ARTICLE_MIXED) {
        store.dispatch(statsActions.adjustPostsCount(1))
      }
      if (action.type === articleModelActions.ARTICLE_UNMIXED) {
        store.dispatch(statsActions.adjustPostsCount(-1))
      }
    }
    next(action)
  }
}

/**
 * @returns {ReduxMiddleware}
 */
// eslint-disable-next-line complexity
function userProfileShowPostsSideEffectsMiddleware() {
  let delayedRemoveArticlePayload = null
  return store => next => action => {
    const state = store.getState()
    if (
      state.profileUser.id !== state.user.id ||
      state.router.action !== 'user-profile.showPosts'
    ) {
      return next(action)
    }
    if (action.type === articleModelActions.ARTICLE_MIXED) {
      store.dispatch(feedActions.prependArticle(action.payload))
      delayedRemoveArticlePayload = null
    }
    if (action.type === articleModelActions.ARTICLE_UNMIXED) {
      if (collectionSelectModalSelectors.isLightweightModalVisible(state)) {
        /**
         * Work-around LWE modal disappearing when the article is removed from the feed.
         * Delay removal so that articles can be easily re-added in case of accidental click
         */
        delayedRemoveArticlePayload = action.payload
      } else {
        store.dispatch(feedActions.removeArticle(action.payload))
      }
    }
    if (action.type === collectionSelectModalActions.HIDE) {
      // If LWE modal disappears, flush the delayed removal
      if (delayedRemoveArticlePayload) {
        store.dispatch(feedActions.removeArticle(delayedRemoveArticlePayload))
        delayedRemoveArticlePayload = null
      }
    }
    next(action)
  }
}

// Exports

module.exports = {
  userProfileStatsSideEffectsMiddleware,
  userProfileShowPostsSideEffectsMiddleware
}
